/** Remember pointer/keyboard selection without moving focus on hover. The returned
 * function restores it when a host rebuilds the same response list. */
export function rememberConversationChoice(list: HTMLElement): () => void {
  let selectedKey: string | null = null;
  const key = (button: HTMLButtonElement) => button.dataset.choice || button.id || button.textContent || "";
  const select = (button: HTMLButtonElement) => {
    if (button.parentElement !== list || button.hidden || button.disabled) return;
    selectedKey = key(button);
    for (const previous of list.querySelectorAll<HTMLElement>("[data-highlighted]")) delete previous.dataset.highlighted;
    button.dataset.highlighted = "true";
  };
  const remember = (event: Event) => {
    const button = event.target instanceof Element ? event.target.closest("button") : null;
    if (button) select(button);
  };
  list.addEventListener("pointerover", remember);
  list.addEventListener("focusin", remember);
  return () => {
    if (selectedKey === null) return;
    const button = Array.from(list.querySelectorAll("button")).find(button => key(button) === selectedKey);
    if (button) select(button);
  };
}
